import { ProductAreaRouteMatcher } from "@faire/web/common/routes/ProductAreaRouteMatcher";
import type { RetailerRoute } from "@faire/web/common/routes/RetailerRouteMatcher";
import { retailerRoutesProductArea } from "@faire/web-api--source/routes/retailerRoutes";

export const RetailerProductAreaRouteMatcher =
  new ProductAreaRouteMatcher<RetailerRoute>(retailerRoutesProductArea);
